export default __webpack_public_path__ + "static/media/card1.7f49342d.png";